import { Route, Routes } from 'react-router-dom';

import Layout from '@/Pages/Layout';
import { PermissionRoute } from '@/components/PermissionRoute';

import Login from '@/Pages/Auth/Login';
import Overview from '@/Pages/Overview/Overview';
import Tenants from '@/Pages/Tenants/Tenants';
import Plans from '@/Pages/Plans/Plans';
import Currencies from '@/Pages/Currencies/Currencies';
import Content from '@/Pages/Content/Content';
import FeatureFlags from '@/Pages/Flags/FeatureFlags';
import Support from '@/Pages/Support';
import ForbiddenPage from '@/Pages/ForbiddenPage';
import NotFoundPage from '@/Pages/NotFoundPage';

/**
 * Every route here demands a `platform.*` permission — a tenant user who
 * somehow reaches this build still gets 403 from both the router and the API.
 */
export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route element={<PermissionRoute permissions={['platform.view', 'platform.manage_tenants']} />}>
        <Route element={<Layout />}>
          <Route index element={<Overview />} />
          <Route path="tenants" element={<Tenants />} />
          <Route path="plans" element={<Plans />} />
          <Route path="currencies" element={<Currencies />} />
          <Route path="content" element={<Content />} />
          <Route path="feature-flags" element={<FeatureFlags />} />
          <Route path="support" element={<Support />} />
          <Route path="403" element={<ForbiddenPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
